// Custom icon static resources

import {
  BulbOutline,
  CreditCardOutline,
  ExceptionOutline,
  FileTextOutline,
  InfoOutline,
  LinkOutline,
  ProfileOutline
} from '@ant-design/icons-angular/icons';

export const ICONS = [
  InfoOutline,
  BulbOutline,
  ProfileOutline,
  ExceptionOutline,
  LinkOutline,
  FileTextOutline,
  CreditCardOutline
];
